import { useMemo } from 'react';

import { REVIEW_STEP_DEFAULT_DEFINITION } from '../../lib/constants';

export default function useSidebarRenderList({ stepsState, phases }) {
  const renderList = useMemo(() => {
    if (!phases) return stepsState.map((s) => ({ type: 'step', data: s }));

    const stateByCode = Object.fromEntries(stepsState.map((s) => [s.code, s]));
    const reviewStep = stateByCode[REVIEW_STEP_DEFAULT_DEFINITION.code];

    return phases.flatMap((phase, index) => {
      const phaseSteps = phase.steps
        .map((s) => stateByCode[s.code])
        .filter(Boolean)
        .sort((a, b) => a.order - b.order)
        .map((s) => ({ type: 'step', data: s }));

      const isLastPhase = index === phases.length - 1;
      const stepsWithVirtual = [
        ...phaseSteps,
        ...(isLastPhase && reviewStep ? [{ type: 'step', data: reviewStep }] : [])
      ];

      return [{ type: 'phase_header', data: phase }, ...stepsWithVirtual];
    });
  }, [phases, stepsState]);

  const flatSteps = useMemo(
    () => renderList.filter((item) => item.type === 'step').map((item) => item.data),
    [renderList]
  );

  return { renderList, flatSteps };
}
